<div class="example-avatar svg" *ngIf="name == 'fill-mask'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'question-answering'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'summary'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'table-qna'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'text-classification'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'text-generation'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'text2tex-generation'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'token-classification'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'translation'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M4.083 9h1.946c.089-1.546.383-2.97.837-4.118A6.004 6.004 0 004.083 9zM10 2a8 8 0 100 16 8 8 0 000-16zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4zm3.971 5c-.089-1.546-.383-2.97-.837-4.118A6.004 6.004 0 0115.917 9h-1.946zm-2.003 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.389.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556zm1.166 4.118c.454-1.147.748-2.572.837-4.118h1.946a6.004 6.004 0 01-2.783 4.118zm-6.268 0C6.412 13.97 6.118 12.546 6.03 11H4.083a6.004 6.004 0 002.783 4.118z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'zero-shot-class'">
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 20 20" height="1em" width="1em"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
            d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z"
            clip-rule="evenodd"></path>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'obj-detection'">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 300 300"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0,300) scale(0.1,-0.1)" fill="#2e95d3" stroke="none">
            <path d="M160 2485 l0 -354 33 -6 c17 -3 57 -4 87 -3 l55 3 5 265 5 265 265 5
            265 5 3 55 c1 30 0 70 -3 88 l-6 32 -354 0 -355 0 0 -355z" />
            <path d="M2124 2753 l1 -88 265 -5 265 -5 5 -265 5 -265 88 -2 87 -2 0 359 0
            360 -359 0 -359 0 2 -87z" />
            <path d="M1075 2230 l-410 -238 0 -492 0 -492 414 -239 c228 -131 417 -239
            421 -239 4 0 194 107 421 239 l414 239 0 492 0 492 -413 239 c-228 131 -419
            239 -425 238 -7 -1 -196 -108 -422 -239z m689 -124 c138 -80 259 -151 269
            -158 16 -12 -11 -30 -250 -168 -147 -85 -275 -154 -283 -154 -22 0 -551 307
            -542 316 17 17 528 308 541 308 8 0 127 -65 265 -144z m-666 -473 c130 -75
            254 -147 275 -160 l37 -23 0 -325 c0 -179 -2 -325 -5 -325 -3 0 -131 73 -285
            162 l-280 161 0 324 c0 218 3 323 10 323 6 0 118 -61 248 -137z m1062 -186 l0
            -324 -280 -161 c-153 -89 -281 -162 -285 -162 -3 0 -5 146 -5 325 l0 325 23
            14 c67 44 524 305 535 305 9 1 12 -70 12 -322z" />
            <path d="M160 519 l0 -359 360 0 359 0 -2 87 -2 88 -265 5 -265 5 -5 265 -5
            265 -87 1 -88 2 0 -359z" />
            <path d="M2658 611 l-3 -266 -265 -5 -265 -5 -1 -87 -1 -88 358 0 359 0 0 358
            0 359 -90 0 -90 -1 -2 -265z" />
        </g>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'img-classification'">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="400pt" height="400pt" viewBox="0 0 200 200"
        preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0,200) scale(0.1,-0.1)" fill="#2e95d3" stroke="none">
            <path d="M835 1651 c-11 -5 -31 -21 -45 -36 -25 -26 -25 -29 -25 -196 l0 -169
            32 -31 c26 -27 41 -33 87 -37 l56 -4 0 -59 0 -59 -190 0 c-238 0 -230 5 -230
            -139 l0 -99 -56 -4 c-46 -4 -61 -10 -87 -37 l-32 -31 0 -170 0 -170 33 -32 32
            -33 170 0 170 0 32 33 33 32 0 170 0 170 -32 31 c-26 27 -41 33 -87 37 l-56 4
            0 59 0 59 360 0 360 0 0 -59 0 -59 -56 -4 c-46 -4 -61 -10 -87 -37 l-32 -31 0
            -170 0 -170 33 -32 32 -33 170 0 170 0 32 33 33 32 0 170 0 170 -32 31 c-26
            27 -41 33 -87 37 l-56 4 0 99 c0 144 8 139 -230 139 l-190 0 0 59 0 59 56 4
            c46 4 61 10 87 37 l32 31 0 170 0 170 -33 32 -32 33 -158 2 c-86 1 -166 -1
            -177 -6z m285 -231 l0 -120 -120 0 -120 0 0 120 0 120 120 0 120 0 0 -120z
            m-420 -840 l0 -120 -120 0 -120 0 0 120 0 120 120 0 120 0 0 -120z m840 0 l0
            -120 -120 0 -120 0 0 120 0 120 120 0 120 0 0 -120z" />
        </g>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'super-resolution'">
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="294.000000pt" height="286.000000pt"
        viewBox="0 0 294.000000 286.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,286.000000) scale(0.100000,-0.100000)" fill="#2e95d3" stroke="none">
            <path d="M1550 1450 c0 -765 3 -1390 6 -1390 12 0 1374 1366 1380 1384 5 15
-135 160 -682 707 -379 379 -692 689 -696 689 -5 0 -8 -625 -8 -1390z" />
            <path d="M1297 2683 c-4 -3 -7 -44 -7 -90 l0 -83 -77 0 c-43 0 -83 -4 -90 -8
-7 -5 -13 -40 -15 -92 l-3 -85 -90 -5 -90 -5 -5 -90 -5 -90 -90 -5 -90 -5 -5
-90 -5 -90 -90 -5 -90 -5 -3 -87 -3 -87 -87 -3 -87 -3 -5 -90 -5 -90 -90 -5
-90 -5 -3 -109 c-2 -81 1 -112 10 -118 7 -4 50 -8 95 -8 l82 0 3 -87 3 -88 88
-3 87 -3 0 -79 c0 -113 -3 -110 101 -110 l89 0 0 -89 c0 -104 -4 -101 111
-101 l79 0 0 -89 c0 -104 -3 -101 110 -101 l79 0 3 -87 3 -88 88 -3 87 -3 0
-82 c0 -45 4 -88 9 -95 5 -9 29 -12 82 -10 l74 3 3 1238 2 1237 -78 0 c-43 0
-82 -3 -85 -7z" />
            <path d="M133 3 c76 -2 198 -2 270 0 73 1 11 3 -138 3 -149 0 -208 -2 -132 -3z" />
        </g>
    </svg>
</div>

<div class="example-avatar svg" *ngIf="name == 'img-segmentation'">
   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path fill="#66798f" d="M35,5v30H5V5H35 M36,4H4v32h32V4L36,4z"></path><rect width="6" height="6" x="32.5" y="1.5" fill="#8bb7f0"></rect><path fill="#4e7ab5" d="M38,2v5h-5V2H38 M39,1h-7v7h7V1L39,1z"></path><rect width="6" height="6" x="1.5" y="1.5" fill="#8bb7f0"></rect><path fill="#4e7ab5" d="M7,2v5H2V2H7 M8,1H1v7h7V1L8,1z"></path><rect width="6" height="6" x="32.5" y="32.5" fill="#8bb7f0"></rect><path fill="#4e7ab5" d="M38,33v5h-5v-5H38 M39,32h-7v7h7V32L39,32z"></path><g><rect width="6" height="6" x="1.5" y="32.5" fill="#8bb7f0"></rect><path fill="#4e7ab5" d="M7,33v5H2v-5H7 M8,32H1v7h7V32L8,32z"></path></g><g><rect width="11" height="11" x="18.5" y="18.5" fill="#dcd5f2"></rect><path fill="#8b75a1" d="M29,19v10H19V19H29 M30,18H18v12h12V18L30,18z"></path></g><g><rect width="11" height="11" x="10.5" y="10.5" fill="#f2faff"></rect><path fill="#788b9c" d="M21,11v10H11V11H21 M22,10H10v12h12V10L22,10z"></path></g></svg>
</div>
